/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_Card4_BodyInputs */

const tr_cerez_s2_card4_body = /** @type {(inputs: Cerez_S2_Card4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanmıyoruz. Üçüncü taraf reklam veya davranışsal profilleme çerezi platformumuzda yer almaz; ileride eklenmesi halinde ayrıca rıza istenir.`)
};

const en_cerez_s2_card4_body = /** @type {(inputs: Cerez_S2_Card4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We do not use them. There are no third party advertising or behavioural profiling cookies on our platform; should they be added in the future, separate consent will be requested.`)
};

const de_cerez_s2_card4_body = /** @type {(inputs: Cerez_S2_Card4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden sie nicht. Cookies Dritter für Werbung oder verhaltensbezogenes Profiling gibt es auf unserer Plattform nicht; sollten sie künftig hinzukommen, wird gesondert um Einwilligung gebeten.`)
};

const ru_cerez_s2_card4_body = /** @type {(inputs: Cerez_S2_Card4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы их не используем. Сторонних рекламных файлов cookie и файлов поведенческого профилирования на нашей платформе нет; в случае их добавления в будущем согласие будет запрошено отдельно.`)
};

/**
* | output |
* | --- |
* | "We do not use them. There are no third party advertising or behavioural profiling cookies on our platform; should they be added in the future, separate conse..." |
*
* @param {Cerez_S2_Card4_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_card4_body = /** @type {((inputs?: Cerez_S2_Card4_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_Card4_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_card4_body(inputs)
	if (locale === "de") return de_cerez_s2_card4_body(inputs)
	if (locale === "ru") return ru_cerez_s2_card4_body(inputs)
	return tr_cerez_s2_card4_body(inputs)
});